import React, { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import micro_reporter_api from "../../apis/micro-reporter-api";
import Utils from "../../libraries/utils";
import Select from "react-select";

const MultiSelectComponent = (props) => {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState();

  useEffect(() => {
    getUniqueValues();
  }, []);

  const getUniqueValues = () => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        const response = await micro_reporter_api.get(
          `/micro-reporter/report/unique-values?reportId=${props.rid}&columnName=${props.cname}`
        );
        setOptions(response.data);
        Utils.loadingScreen("hide");
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    }
  };

  const convertSelectedValuesToArray = (selectedList) => {
    let options = [];
    for (const [key, value] of Object.entries(selectedList)) {
      let second = null;
      let filterType = "TEXT_EQUALS";
      let filterData = {};
      filterData["first"] = value.value;
      filterData["second"] = second;
      filterData["filterType"] = filterType;
      options.push(filterData);
    }
    return options;
  };

  const setPropsValues = (columnName) => {
    props.resetSelectChange();

    if (selectedOptions?.length > 0) {
      let obj = {};
      let array = convertSelectedValuesToArray(selectedOptions);
      obj[columnName] = array;
      props.resetSelect ? (() => {
        setSelectedOptions([]);
        props.resetSelectChange();
      })() : props.setMultiSelectedOptions(obj);
    }
  };
  setPropsValues(props.cname);

  return (
    <Form.Group as={Col} md="4">
      <Form.Label>{props.cname}</Form.Label>
      <Select
        name={props.cname}
        value={selectedOptions}
        onChange={setSelectedOptions}
        options={options}
        className="clear-selected-button"
        isSearchable={true}
        isMulti
      />
    </Form.Group>
  );
};

export default MultiSelectComponent;
